export default {
  project(param) {
    switch (param) {
      case 'dom-kamionki':
        return 'Dom Kamionki';
      case 'poznan':
        return 'Poznań';
      case 'wroclaw':
        return 'Wrocław';
      case 'kuchnia-kamionki':
        return 'Kuchnia Kamionki';
      case 'stomatolog-osiedle-river-park':
        return 'Stomatolog os. River Park';
      case 'dusseldorf-wonder-photo-shop':
        return 'Dusseldorf Wonder Photo Shop';
      default:
        return '';
    }
  },
};
